import { useEffect, useState } from "react";
import {
  Badge,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "../../API/axios";
import {
  getConnectionList,
  getMessageList as fetchMessageList,
  getUnreadMessagesCount,
  isChatPinned,
  MESSAGE_LIST_CHANGED_EVENT,
  MESSAGE_LIST_DROPDOWN_COUNT,
  MESSAGE_LIST_PAGE_PARAMS,
  parseMessageListResponse,
  syncUnreadMessageCountFromChats,
} from "../../Services/apiService";
import { getChatUnreadCount } from "../../utils/chatReadUtils";
import { formatMessagePreviewText } from "../../utils/messageReplyUtils";
import MessageList from "../Message/MessageList";
import { people, post, svg } from "../../config/imagesLink";
import MessageInteraction from "../Message/MessageInteraction";
// import SmsSharpIcon from '@mui/icons-material/SmsSharp';
import TextsmsSharpIcon from '@mui/icons-material/TextsmsSharp';
import PushPinSharpIcon from '@mui/icons-material/PushPinSharp';
import { ListRowSkeleton } from "@skeleton";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import "../Message/Message.css";

const { pin } = svg;

export default function TopMessage({
  MessagesCount,
  closeTooltip,
  msgCount: msgCountProp,
  setMsgCount: setMsgCountProp,
}) {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();

  const [notifi, setNotifi] = useState([]);
  const [msgCount, setMsgCount] = useState(() => {
    const stored = localStorage.getItem("MsgCountData");
    return stored != null && stored !== "" ? Number(stored) : 0;
  });

  const displayCount =
    msgCountProp !== undefined && msgCountProp !== null && msgCountProp !== ""
      ? Number(msgCountProp) || 0
      : Number(msgCount) || 0;

  const applyCount = (count) => {
    if (count == null) return;
    setMsgCount(count);
    setMsgCountProp?.(count);
  };
  const formattedTime = moment("aaa").fromNow();
  const language = localStorage.getItem("Lang");
  const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  //   const sessionId = localStorage.getItem('sessionId')
  const [msgId, setMsgId] = useState("");
  const [connectionUser, setConnectionUser] = useState("");
  const [userName, setUserName] = useState("");
  const [chatList, setChatList] = useState("");
  //************************Message List Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [messageList, setmessageList] = useState([]);
  const [show, setShow] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const [page, setPage] = useState(1);
  const [active, setActive] = useState();
  const [archiveActive, setArchiveActive] = useState();
  const [archiveMessage, setArchiveMessage] = useState(false);
    const [isError, setIsError] = useState(true);
  
  const getMessageList = ({ forceRefresh = false, silent = false } = {}) => {
    if (!silent) {
      setIsLoading(true);
    }

    // Exact same GetMessageList params as the Messages page so both views
    // share one cache entry and the same isPined flags.
    fetchMessageList({
      forceRefresh,
      variant: "page",
      pageNumber: 0,
      pageSize: MESSAGE_LIST_PAGE_PARAMS.pageSize,
      topCount: MESSAGE_LIST_PAGE_PARAMS.topCount,
    })
      .then((response) => {
        if (!response) return;
        if (response.data.responseData?.chatID != null) {
          localStorage.setItem(
            "MessageChatId",
            response.data.responseData.chatID
          );
        }

        const items = parseMessageListResponse(response).slice(
          0,
          MESSAGE_LIST_DROPDOWN_COUNT
        );
        setmessageList(items);
        syncUnreadMessageCountFromChats(items);
        setIsLoading(false);
        setIsError(false);
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.status === 404 || error.status === 404) {
          setIsLoading(false);
          setIsError(true);
        } else {
          console.log("error", error.response?.status);
        }
      });
  };

  useEffect(() => {
    const onMessageListChanged = () => {
      // Cache was cleared by invalidateMessageList; reload with the same
      // params as the chat list so pin icons stay aligned.
      getMessageList({ forceRefresh: false, silent: true });
    };
    window.addEventListener(MESSAGE_LIST_CHANGED_EVENT, onMessageListChanged);
    return () => {
      window.removeEventListener(
        MESSAGE_LIST_CHANGED_EVENT,
        onMessageListChanged
      );
    };
  }, []);
  // useEffect(() => {
  //   getMessageList();
  // }, []);

  //************************Message List End  ************************//

  //************************ Connection  List   ************************//
  const [ConnectionList, setConnectionList] = useState([]);
  const [searchconnectList, setSearchconnectList] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");
  // console.log('ConnectionList', ConnectionList);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);

  const ConnectionListAll = async (id) => {
    // console.log('calles');
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 10,
      type: "ConnectionList",
      search: searchUserName,
      langKey: language === "en" ? "" : language,

    };
    try {
      await getConnectionList(data).then((resData) => {
        // console.log("resData", resData);
        // setConnectionList(resData.data.responseData.viewList);
        setIsLoading(false);

        if (searchUserName !== "") {
          // return newPosts;
          setConnectionList([]);
          setSearchconnectList(resData.data.responseData.viewList);
        } else {
          setSearchconnectList([]);
          // setConnectionList((prev) => [
          //   ...prev,
          //   ...resData.data.responseData.viewList,
          // ]);
          // const newPosts = resData.data.responseData.viewList;
          // setPostList((prev) => {
          //   const postSet = new Set(prev.map((post) => post.postId));
          //   const uniqueNewPosts = newPosts.filter(
          //     (post) => !postSet.has(post.postId)
          //   );
          //   return [...prev, ...uniqueNewPosts];
          // });
          setConnectionList((prev) => {
            const newViewList = resData?.data?.responseData?.viewList.filter(
              (item) =>
                !prev.some((prevItem) => prevItem.cnctnId === item.cnctnId)
            );
            return [...prev, ...newViewList];
          });
        }
      });
    } catch (error) {
      if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true)
      }
    }
  };

  useEffect(() => {
    if (show) {
      ConnectionListAll();
    }
  }, [show, searchUserName]);

  //************************Connection List ************************//

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);

  const handleSendMessage = (item) => {
    const userExistsInMessageList = messageList.some(
      (message) => message.chatInfo.toUserId === item.connectsWithUserUid
    );
    if (userExistsInMessageList) {
      // Perform the action if user exists in the message list
      // console.log("User exists in the message list");
      // Call the function you need to execute when user exists
    } else {
      setChatList("");
      setConnectionUser(item.connectsWithUserUid);
      setUserName(item.connectsWithUserName);
      setShow(false);
    }
  };

  //************************Archived List Start  ************************//
  // const [archivedList, setArchivedList] = useState([]);
  // const getArchivedList = () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`Message/GetArchivedMessageList`, data)
  //     .then((response) => {
  //       const res = response.data.responseData;
  //       setArchivedList(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getArchivedList();
  // }, []);
  //************************Archived List End  ************************//

  const [showClear, setShowClear] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [activeTab, setActiveTab] = useState(1);
  const [isShown, setIsShown] = useState(true);

  //************************Message Count End  ************************//

  const fetchMessagesCount = async ({ forceRefresh = false } = {}) => {
    try {
      const count = await getUnreadMessagesCount({ forceRefresh });
      if (count != null) {
        applyCount(count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!sessionId) return undefined;

    fetchMessagesCount({ forceRefresh: true });

    const handleUserLoggedIn = () => {
      fetchMessagesCount({ forceRefresh: true });
    };

    const handleCountUpdated = (event) => {
      const count = event?.detail?.count;
      if (count != null) {
        applyCount(count);
      }
    };

    window.addEventListener("userLoggedIn", handleUserLoggedIn);
    window.addEventListener("messageCountUpdated", handleCountUpdated);

    return () => {
      window.removeEventListener("userLoggedIn", handleUserLoggedIn);
      window.removeEventListener("messageCountUpdated", handleCountUpdated);
    };
  }, [sessionId]);

  //  const MessagesCount = async () => {
  //     const data = {
  //       deviceType: "Web",
  //       sessionId: sessionId,
  //     };
  //     try {
  //       // setLoading(true);
  //       await axios
  //         .post(`Message/AllUnreadMsgsCount`, data)
  //         .then((resData) => {
  //           // setMsgCount(resData.data.responseData);

  //           if (msgCount !== resData.data.responseData) {
  //             setMsgCount(resData.data.responseData);
  //           }
  //           console.log("messagecountTotal" ,resData.data.responseData );

  //         });
  //     } catch (error) {
  //       console.log(error);

  //     }
  //   }; 

  //    useEffect(() => {
  //     const sessionId = localStorage.getItem("sessionId");
  //     if (sessionId) {
  //       (async () => { 
  //         await Promise.all([ 
  //           MessagesCount()
  //         ]);
  //       })();
  //     } 
  //   }, []);


  return (
    <>
      <UncontrolledDropdown
        className="dropdown-notification"
        onToggle={(_e, isOpen) => {
          if (isOpen) {
            closeTooltip?.();
            getMessageList({ forceRefresh: true, silent: messageList.length > 0 });
          }
        }}
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="nav-link notification-toggle"
          caret={false}
          onClick={(e) => {
            e.preventDefault();
            closeTooltip?.();
          }}
        >
          <TextsmsSharpIcon className="material-symbols-sharp" />
          {displayCount > 0 ? (
            <Badge pill color="danger" className="badge-up notifictaionBadge">
              {displayCount > 99 ? "99+" : displayCount}
            </Badge>
          ) : (
            ""
          )}
        </DropdownToggle>
        <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0 notificationDropdown topmessages" onMouseEnter={closeTooltip}
          onMouseLeave={closeTooltip}>
          {/* {messageList.length === 0 ? <h4 className="notification-title mb-0 me-auto text-center">No Message</h4> : */}
          <>

            <li className="dropdown-menu-header">
              <DropdownItem className="d-flex" tag="div" header>
                <h4 className="notification-title mb-0 me-auto">{t("Notifications.Messages")}</h4>
                <div className="badge badge-notificationCount me-3 mb-1">
                  {displayCount} {t("Notifications.New")}
                </div>
              </DropdownItem>
            </li>

            {isLoading ? (
              <div className="notificationscroller">
                <ListRowSkeleton count={5} rowHeight={50} showAvatar />
              </div>
            ) :isError || messageList.length === 0 ? (
              <div className="notificationscroller text-center errorimg my-3">
                {/* <img src={emptyMessageImage} alt="No Messages" width={80} /> */}
                <img src={post.errorSmall} alt="Error" width={200} />

                {/* <p className="text-muted mt-2">{t("Notifications.No messages found")}</p> */}
              </div>
            ) : (
              <div className="notificationscroller">
              {messageList.map((item, index) => {
                const unreadCount = getChatUnreadCount(item);
                const showUnreadBadge = unreadCount > 0;
                const unreadBadgeLabel = unreadCount > 99 ? "99+" : unreadCount;
                const isPinned = isChatPinned(item);
                const formattedTime = moment(item.lastMsgTime).fromNow();
                 const now = moment();
                 const itemTime = moment.utc(item.lastMsgTime);
                 const duration = moment.duration(now.diff(itemTime));

                 const years = duration.years();
                 const months = duration.months();
                 const days = duration.days();
                 const hours = duration.hours();
                 const minutes = duration.minutes();

                 let result = "";

                 if (years > 0) {
                   result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (months > 0) {
                   result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (days > 0) {
                   result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (hours > 0) {
                   result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else if (minutes > 0) {
                   result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                 } else {
                   result = t("Notifications.Just Now");
                 }

                               {/* const now = moment.utc().local();
                                    const itemTime = moment.utc(item.lastMsgTime).local();
                
                                    const diffSeconds = now.diff(itemTime, "seconds");
                                    const diffMinutes = now.diff(itemTime, "minutes");
                                    const diffHours = now.diff(itemTime, "hours");
                                    const diffDays = now.diff(itemTime, "days");
                
                                    const diffMonths = now.diff(itemTime, "months", true);
                                    const diffYears = now.diff(itemTime, "years", true);
                
                                    let result = "";
                 
                                    if (diffSeconds < 60) {
                                      result = t("Notifications.Just Now");
                                    }
                 
                                    else if (diffMinutes < 60) {
                                      result =
                                        diffMinutes === 1
                                          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                                          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else if (diffHours < 24) {
                                      result =
                                        diffHours === 1
                                          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                                          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else if (diffDays < 30) {
                                      result =
                                        diffDays === 1
                                          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                                          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else if (diffMonths < 12) {
                                      const displayMonth =
                                        diffMonths >= 0.75 && diffMonths < 1.25
                                          ? 1
                                          : Math.round(diffMonths * 2) / 2;
                
                                      result =
                                        displayMonth === 1
                                          ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                                          : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                                    }
                 
                                    else {
                                      const displayYear =
                                        diffYears >= 0.75 && diffYears < 1.25
                                          ? 1
                                          : Math.round(diffYears * 2) / 2;
                
                                      result =
                                        displayYear === 1
                                          ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                                          : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                                    } */}
                

                return (
                  <li
                    className="dropdown-menu-header"
                    key={item?.chatInfo?.toUserUid || item?.chatID || index}
                  >
                    <DropdownItem
                      tag={Link}
                      to={`/Message/${item?.chatInfo?.toUserUid}`}
                      onClick={() => {
                        setActive(index);
                        setMsgId(item?.chatInfo?.msgID);
                      }}
                      className="topnotification d-flex align-items-center"
                    >
                      <img
                        src={item?.chatInfo?.toUserImage || people.DefaultProfile}
                        onError={(e) => {
                          e.target.src = people.DefaultProfile;
                        }}
                        width={40}
                        height={40}
                        style={{ borderRadius: "50%" }}
                        className="me-3"
                        alt=""
                      />

                      <div className="notification-text flex-grow-1">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="notification-message mb-0 d-flex align-items-center">
                            <span>{item?.chatInfo?.toUserFullName}</span>
                          </div>
                          <span
                            className={`side-text ms-0 ${
                              showUnreadBadge ? "message-time-unread" : ""
                            }`}
                          >
                            {result}
                          </span>
                        </div>

                        <div className="d-flex align-items-center justify-content-between">
                          <div className="mb-0 content-text me-2">
                            <span>
                              {item?.isOwned && `${t("Notifications.You")}: `}
                              {(() => {
                                const preview = formatMessagePreviewText(item?.lastMsg || "");
                                return preview.length > 35
                                  ? `${preview.slice(0, 35)}...`
                                  : preview;
                              })()}
                            </span>
                          </div>

                          <div className="msg-preview-meta">
                            {showUnreadBadge ? (
                              <span
                                className={`msg-unread-badge ${
                                  unreadCount > 9 ? "msg-unread-badge-wide" : ""
                                }`}
                              >
                                {unreadBadgeLabel}
                              </span>
                            ) : null}
                            {isPinned ? (
                              <PushPinSharpIcon className="material-symbols-sharp msg-pin-icon pin-icon" />
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </DropdownItem>
                  </li>
                );
              })}
              </div>
            )}



            <li className="dropdown-menu-footer">
              <Link tag={Link} to="/Message/All">
                <button
                  type="submit"
                  className="wljPrimaryBtn d-flex align-items-center mt-2 mb-2 noti-btn"
                >
                  {t("Notifications.View all messages")}
                </button>
              </Link>
            </li>
          </>
          {/* // } */}
        </DropdownMenu>
      </UncontrolledDropdown>
      {
        unauthorisedModal && (
          <div
            className="modal fade show postAdd"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                    <p className="text-center ad-p">
                      {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                    </p>
                    <div className="text-center m-auto mt-3">
                      <button
                        type="button"
                        className="mainBtn1 "
                        onClick={() => {
                          setUnauthorisedModal(!unauthorisedModal)
                          navigate("/SignIn");
                          localStorage.clear();
                          sessionStorage.removeItem('hasModalShown');
                        }}
                      >
                        {t("modals.login")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>

  );

}
